<template>
  <div class="tag-anchor" :style="styles">
    <div class="tag-anchor__pos" :class="`tag-anchor__pos--tail-${tailPosition}`">
      <div
        class="tag-rich"
        :class="classes"
      >
        <div class="tag-rich__inner" :class="{ 'tag-rich__inner--expand' : active }">
          <div v-if="label" class="tag-rich__content-col" :class="{ 'dir-rtl' : rtl }">
            <div class="tag-rich__label" v-html="label[lang]"></div>
            <div class="tag-rich__description" v-html="description[lang]"></div>
            <div v-if="moreInformation[lang]" class="tag-rich__info-icon">(More)</div>
          </div>
          <div v-if="moreInformation[lang]" class="tag-rich__content-col-extra" :class="{ 'dir-rtl' : rtl }">
            <div class="tag-rich__description" v-html="moreInformation[lang]"></div>
          </div>
          <div class="tag-rich__image-col" v-if="asset && asset.type === 'image'">
            <div class="tag-rich__image-clip">
              <img class="tag-rich__image" :src="`${$store.state.assetsPath}${asset.path}`"> 
            </div>
          </div>
          <div class="tag-rich__image-col" v-if="asset && asset.type === 'video'">
            <div class="tag-rich__image-clip">
              <video
                class="tag-rich__video"
                :src="`${$store.state.assetsPath + asset.path}`"
                autoplay
                muted
                loop
              ></video>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'flip', 'label', 'type', 'tail-position', 'description', 'image', 'lang', 'rtl', 'asset', 'active', 'more-information'],

  data () {
    return {
      wooshCloseSound: null,
      wooshOpenSound: null
    }
  },

  computed: {
    classes () {
      let classes = {}
      classes[`tag-rich--tail-${this.tailPosition}`] = true
      classes['tag-rich--flip'] = this.forceFlip
      return classes
    },

    forceFlip () {
      if (this.tailPosition.includes('right-center')) {
        return true
      }

      if (this.tailPosition.includes('left-center')) {
        return false
      }

      return this.flip
    },

    styles () {
      return {
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }
    }
  },

  mounted () {
    this.wooshCloseSound = new Audio('/assets/sounds/woosh_close.mp3')
    this.wooshOpenSound = new Audio('/assets/sounds/woosh_open.mp3')
  },

  watch: {
    active () {
      if (this.active) {
        this.wooshOpenSound.pause()
        this.wooshOpenSound.currentTime = 0
        this.wooshOpenSound.play()
      } else {
        this.wooshCloseSound.pause()
        this.wooshCloseSound.currentTime = 0
        this.wooshCloseSound.play()        
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";

.tag-anchor {
  font-size: 1em;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transform: translateY(1rem);
  transition: opacity 1.2s, transform 0.6s;
  z-index: 15;

  &__pos {
    height: 0;
    width: 0;

    &--tail-top-left:after,
    &--tail-top-center:after,
    &--tail-top-right:after {
      @include tail3($rich-tag-bg-color-solid);
    }

    &--tail-bottom-left:after,
    &--tail-bottom-center:after,
    &--tail-bottom-right:after {
      @include tail3($rich-tag-bg-color-solid);
    }

    &--tail-left-center:after {
      @include tail3($rich-tag-bg-color-solid);
    }

    &--tail-right-center:after {
      @include tail3($rich-tag-bg-color-solid);
    }

    &--tail-top-left:before,
    &--tail-top-center:before,
    &--tail-top-right:before {
      background: $rich-tag-bg-color;
      box-shadow: $tag-box-shadow;
      content: '';
      height: 8em;
      left: 0;
      position: absolute;
      top: 0;
      transform: translateX(-50%);
      width: .25em;
    }

    &--tail-bottom-left:before,
    &--tail-bottom-center:before,
    &--tail-bottom-right:before {
      background: $rich-tag-bg-color;
      bottom: 0;
      box-shadow: $tag-box-shadow;
      content: '';
      height: 8em;
      left: 0;
      position: absolute;
      transform: translateX(-50%);
      width: .25em;
    }

    &--tail-left-center:before {
      background: $rich-tag-bg-color;
      bottom: -50%;
      box-shadow: $tag-box-shadow;
      content: '';
      height: .25em;
      left: 0;
      position: absolute;
      transform: translateY(50%);
      width: 8em;
    }

    &--tail-right-center:before {
      background: $rich-tag-bg-color;
      bottom: -50%;
      box-shadow: $tag-box-shadow;
      content: '';
      height: .25em;
      right: 0;
      position: absolute;
      transform: translateY(50%);
      width: 8em;
    }
  }

  div[class^='tag-rich--tail-top'],
  div[class*=' tag-rich--tail-top'] {
    
    .tag-rich__inner {
      transform-origin: top;
    }
  }

  div[class^='tag-rich--tail-bottom'],
  div[class*=' tag-rich--tail-bottom'] {
    
    .tag-rich__inner {
      transform-origin: bottom;
    }
  }

  div[class^='tag-rich--tail-right'],
  div[class*=' tag-rich--tail-right'] {
    
    .tag-rich__inner {
      transform-origin: right;
    }
  }

  div[class^='tag-rich--tail-right-center'],
  div[class*=' tag-rich--tail-right-center'] {
    
    .tag-rich__inner {
      transform-origin: center;
    }
  }

  div[class^='tag-rich--tail-left'],
  div[class*=' tag-rich--tail-left'] {
    
    .tag-rich__inner {
      transform-origin: left;
    }
  }

  .tag-rich__image-col .tag-rich__image,
  .tag-rich__image-col .tag-rich__video {
    transition: all 750ms ease-out 350ms;
  }

  &.enter {
    opacity: 1;
    transform: translateY(0);
  }

  &.enter,
  &.leave {
    .tag-rich__image-col .tag-rich__image,
    .tag-rich__image-col .tag-rich__video {
      transform: translateX(0);
    }
  }
}

.tag-rich {
  background-color: transparent;
  color: $rich-tag-font-color;
  font-family: $touchscreen-font;
  font-size: $rich-tag-font-size;
  height: 14em;
  letter-spacing: .05em;
  line-height: 1.2em;
  overflow: visible;
  pointer-events: none;
  position: absolute;
  transition: all 350ms ease-in-out;
  width: 17em;
  z-index: 5;

  * {
    pointer-events: none;
    user-select: none;
  }

  &--flip {
    .tag-rich__inner {
      transform-origin: left;

      &--expand {
        .tag-rich__content-col-extra {
          border-bottom-left-radius: $rich-tag-border-radius;
          border-top-left-radius: $rich-tag-border-radius;
          border-bottom-right-radius: 0;
          border-top-right-radius: 0;
          transform: translateX(-95%);
        }
      }
    }

    .tag-rich__image-col {
      transform: translateX(-195%);

      .tag-rich__image-clip {
        clip-path: polygon(98% 0%, 96% 1%, 95.5% 2%, 95% 3%, 95% 50%, 95% 97%, 95.5% 98%, 96% 99%, 98% 100%, 0% 100%, 0% 50%, 0% 0%);
        height: 100%;
      }

      .tag-rich__image {
        height: 100%;
        transform: translateX(92%);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }

      .tag-rich__video {
        height: 100%;
        transform: translateX(92%);
        width: 100%;
        object-fit: cover;
        border-radius: $rich-tag-border-radius;
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }

  &--tail-top-left {
    left: -$rich-tag-font-size * 2;
    top: 8em / $rich-tag-font-size + em;
  }

  &--tail-top-center {
    left: 50%;
    top: 8em / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-top-right {
    right: -$rich-tag-font-size * 2;
    top: 8em / $rich-tag-font-size + em;
  }

  &--tail-bottom-left {
    left: -$rich-tag-font-size * 2;
    bottom: 8em / $rich-tag-font-size + em;
  }

  &--tail-bottom-center {
    left: 50%;
    bottom: 8em / $rich-tag-font-size + em;
    transform: translateX(-50%);
  }

  &--tail-bottom-right {
    right: -$rich-tag-font-size * 2;
    bottom: 8em / $rich-tag-font-size + em;
  }

  &--tail-left-center {
    left: 8em / $rich-tag-font-size + em;
    transform: translateY(-50%);
  }

  &--tail-right-center {
    right: 8em / $rich-tag-font-size + em;
    transform: translateY(-50%);
  }

  &__inner {
    display: flex;
    height: 14em;
    position: absolute;
    transition: transform 300ms ease;
    width: 34em;

    &--expand {
      transform: scale(1.25);

      .tag-rich__content-col-extra {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        transform: translateX(97%);
      }
    }
  }

  &__image-col {
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    height: 100%;
    left: 0;
    top: 0;
    width: 50%;
    filter: drop-shadow($tag-box-shadow);
    overflow: hidden;
    pointer-events: auto;
    transform: translateX(-3%);
  }

  &__image-clip {
    clip-path: polygon(100% 0%, 100% 50%, 100% 100%, 0% 100%, 2% 99%, 2.5% 98%, 3% 97%, 3% 50%, 3% 3%, 2.5% 2%, 2% 1%, 0% 0%);
    height: 100%;
  }

  &__image {
    height: 100%;
    transform: translateX(-92%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__video {
    height: 100%;
    transform: translateX(-92%);
    width: 100%;
    object-fit: cover;
    border-radius: $rich-tag-border-radius;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }

  &__content-col {
    background: $rich-tag-bg-color-solid;
    border-radius: $rich-tag-border-radius;
    box-shadow: $tag-box-shadow;
    height: 100%;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: relative;
    width: 50%;
    z-index: 2;
  }

  &__content-col-extra {
    background: rgba($rich-tag-bg-color-solid, .8);
    border-radius: $rich-tag-border-radius;
    box-shadow: none;
    height: 100%;
    left: 0;
    overflow: hidden;
    padding: 1.5em;
    pointer-events: auto;
    position: absolute;
    transition: 300ms all 100ms ease-in-out;
    width: 50%;
    z-index: 1;
  }

  &__label {
    font-size: 1.3em;
    font-weight: 300;
    line-height: 1.1em;
    margin-bottom: .6em;
    margin-top: .1em;
    -webkit-font-smoothing: auto;
  }

  &__description {
    font-size: 0.75em;
    font-weight: 200;
    line-height: 1.4;
  }

  &__info-icon {
    bottom: .5rem;
    position: absolute;
    right: .75rem;
  }
}
</style>
